<template>
    <div>
        <v-expansion-panels flat>
            <v-expansion-panel v-for="(contracts, type) in contractsByType" :key="type">
                <v-expansion-panel-header>
                    <h2 class="font-weight-light d-flex justify-center mb-6">
                        <v-badge
                            :content="contracts.length"
                            :value="contracts.length"
                            color="red darken-3"
                        >
                            {{ type }}
                        </v-badge>
                    </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-data-table
                        :headers="headers"
                        :items="contracts"
                        :items-per-page="5"
                        :items-per-page-options="[5, 10, 20]"
                        class="elevation-0"
                    >
                        <template v-slot:item="{ item }">
                            <tr v-if="$vuetify.breakpoint.smAndUp" style="height: 100px; background-color: #f0f0f0;">
                                <td>
                                    <v-icon large color="red">mdi-file-pdf-box</v-icon>
                                </td>
                                <td>{{ item.account.nombre_completo }}</td>
                                <td>{{ item.contract_name }}</td>
                                <td>
                                    <a :href="item.contract" target="_blank" download style=" text-decoration: none;">
                                        <v-icon large color="green">mdi-file-download-outline</v-icon>
                                    </a>
                                </td>
                                <td v-if="hasAdminPermission">
                                    <v-icon @click="deleteContract(item.id)" large color="red">mdi-delete-outline</v-icon>
                                </td>
                            </tr>
                            <tr v-else style="background-color: #f0f0f0;" class="pa-6">
                                <div class="d-flex flex-column justify-space-between">
                                    <p class="d-flex justify-space-between"><strong>Nombre: </strong> {{ item.account.nombre_completo }}</p>
                                    <p class="d-flex justify-space-between"><strong>Contrato: </strong> {{ item.contract_name }}</p>
                                    <div class="d-flex justify-space-around">
                                        <a :href="item.contract" target="_blank" download style=" text-decoration: none;">
                                            <v-icon large color="green">mdi-file-download-outline</v-icon>
                                        </a>
                                        <v-icon @click="deleteContract(item.id)" large color="red">mdi-delete-outline</v-icon>
                                    </div>
                                </div>
                            </tr>
                            <v-divider v-if="!$vuetify.breakpoint.smAndUp"></v-divider>
                        </template>
                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="!Object.keys(contractsByType).length">
                <v-expansion-panel-header>
                    <h2 class="font-weight-light d-flex justify-center mb-6">
                        No hay contratos
                    </h2>
                </v-expansion-panel-header>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { clone } from '@/util/libUtil.js';

export default {
    data: ()=> ({
        headers: [
            { text: '', value: '' },
            { text: 'Nombre', value: 'account.nombre_completo' },
            { text: 'Tipo', value: 'contract_name' },
            { text: 'Descargar', value: 'contract' },
            { text: 'Borrar', value: 'delete' },
        ],
    }), 
    computed: {
        contractsByType() {
            let contracts = {};
            this.userContracts.forEach(contract => {
                if (!contracts[contract.contract_type]) {
                    contracts[contract.contract_type] = [];
                }
                contracts[contract.contract_type].push(contract);
            });
            return contracts;
        },
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
        ...mapState('storage', {
            userContracts: state => state.userContracts.contracts,
        }),
    },
    methods: {
        deleteContract(id) {
            let deleteObj = {
                toDeleteId: id,
                toDeleteType: 'STORAGE_CONTRACT',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        }
    },
    beforeMount() {
        if (!this.hasAdminPermission) {
            this.headers.splice(4, 1);
        }
    }
}
</script>

<style scoped>
.grey-card {
    background-color: #f0f0f0;
}
</style>